import { render, staticRenderFns } from "./regionCard.vue?vue&type=template&id=819c2062&scoped=true"
import script from "./regionCard.vue?vue&type=script&lang=js"
export * from "./regionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819c2062",
  null
  
)

export default component.exports